import { NOTIFY, SET, INITIATE_CLOSE, CLOSED } from './constants';

const DEFAULT_DURATION = 8000;

export function notify({
  message,
  duration = DEFAULT_DURATION,
  anchorOrigin = {
    vertical: 'bottom',
    horizontal: 'left'
  },
  showClose = true,
  variant,
  reason
}) {
  return {
    type: NOTIFY,
    payload: {
      message,
      ...(reason ? undefined : {duration: duration}),
      anchorOrigin,
      showClose,
      variant
    }
  };
}

export function set(payload) {
  return {
    type: SET,
    payload
  };
}

export function closed() {
  return {
    type: CLOSED
  };
}

export function initiateClose() {
  return {
    type: INITIATE_CLOSE
  };
}
